'use client';

import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Chip,
} from '@mui/material';
import {
  Menu as MenuIcon,
} from '@mui/icons-material';

interface TopBarProps {
  marketStatus?: 'OPEN' | 'CLOSED' | 'PRE_MARKET' | 'AFTER_HOURS';
  onMenuClick?: () => void;
}

export function TopBar({ marketStatus = 'CLOSED', onMenuClick }: TopBarProps) {
  const getMarketStatusColor = () => {
    switch (marketStatus) {
      case 'OPEN':
        return 'success';
      case 'PRE_MARKET':
      case 'AFTER_HOURS':
        return 'warning';
      default:
        return 'default';
    }
  };

  const getMarketStatusLabel = () => {
    switch (marketStatus) {
      case 'OPEN':
        return 'Market Open';
      case 'PRE_MARKET':
        return 'Pre-Market';
      case 'AFTER_HOURS':
        return 'After Hours';
      default:
        return 'Market Closed';
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'background.paper',
        color: 'text.primary',
        boxShadow: 'none',
        borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
      }}
    >
      <Toolbar>
        {/* Mobile menu button */}
        <Box sx={{ display: { xs: 'block', md: 'none' }, mr: 1 }}>
          <IconButton color="inherit" edge="start" aria-label="open drawer" onClick={onMenuClick}>
            <MenuIcon />
          </IconButton>
        </Box>

        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          Dual AI Capital
        </Typography>

        {/* Market Status */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Chip
            label={getMarketStatusLabel()}
            color={getMarketStatusColor()}
            size="small"
            sx={{ fontWeight: 600 }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
